import React from "react";
import { smoothPath } from "./dashboardFormat";

const WIDTH = 96;
const HEIGHT = 36;

// Drawn in a fixed coordinate space and stretched to its box, so the card decides the size.
const Sparkline = ({ values = [], color, delay = 0, className = "" }) => {
  if (values.length < 2) return <svg className={className} aria-hidden="true" />;

  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const points = values.map((v, i) => [
    2 + (i * (WIDTH - 4)) / (values.length - 1),
    HEIGHT - 4 - ((v - min) / span) * (HEIGHT - 10),
  ]);
  const line = smoothPath(points);
  const area = `${line} L${points[points.length - 1][0]},${HEIGHT} L${points[0][0]},${HEIGHT} Z`;

  return (
    <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`} preserveAspectRatio="none" aria-hidden="true" className={className}>
      <path d={area} fill={color} fillOpacity="0.12" className="dash-fade" style={{ animationDelay: `${delay}ms` }} />
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
        pathLength="1"
        className="dash-draw"
        style={{ animationDelay: `${delay}ms` }}
      />
    </svg>
  );
};

export default Sparkline;
